"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeplrViewingKeyManager = exports.ViewingKeyManager = void 0;
var events_1 = require("./events");
var bootstrap_1 = require("./bootstrap");
var wallet_1 = require("./wallet");
var ViewingKeyManager = (function () {
    function ViewingKeyManager() {
        this.accounts = [];
        var item = localStorage.getItem('griptape.js');
        if (item) {
            this.accounts = JSON.parse(item);
        }
    }
    ViewingKeyManager.prototype.add = function (contract, key) {
        var _this = this;
        if (!key)
            throw new Error('Empty or undefined key cannot be added');
        var form = {
            id: contract.id,
            contractAddress: contract.at,
            key: key,
        };
        var account = this.getAccount();
        if (!account) {
            account = this.addAccount();
        }
        if (!account)
            throw new Error('No account available');
        var theKey = account === null || account === void 0 ? void 0 : account.keys.find(function (it) { return _this.isKeyAdded(it, form); });
        if (theKey)
            return theKey.value;
        var newKey = this.createKey(form);
        account.keys.push(newKey);
        localStorage.setItem('griptape.js', JSON.stringify(this.accounts));
        events_1.emitEvent('viewing-key-created');
        return newKey.value;
    };
    ViewingKeyManager.prototype.set = function (contract, key) {
        var _this = this;
        var form = {
            id: contract.id,
            contractAddress: contract.at,
            key: key,
        };
        var account = this.getAccount();
        if (!account) {
            account = this.addAccount();
        }
        var theKey = account === null || account === void 0 ? void 0 : account.keys.find(function (it) { return _this.isKeyAdded(it, form); });
        if (!theKey)
            return;
        theKey.value = key;
        localStorage.setItem('griptape.js', JSON.stringify(this.accounts));
    };
    ViewingKeyManager.prototype.get = function (idOrAddress) {
        var _this = this;
        var account = this.getAccount();
        if (!account) {
            account = this.addAccount();
        }
        var key = account === null || account === void 0 ? void 0 : account.keys.find(function (it) { return _this.isEqual(it, idOrAddress); });
        if (!key)
            return;
        return key.value;
    };
    ViewingKeyManager.prototype.createKey = function (form) {
        var id = form.id, contractAddress = form.contractAddress, value = form.key;
        return {
            id: id,
            contractAddress: contractAddress,
            value: value,
        };
    };
    ViewingKeyManager.prototype.addAccount = function () {
        var address = bootstrap_1.getAddress();
        if (!address)
            return;
        var account = { address: address, keys: [] };
        this.accounts.push(account);
        return account;
    };
    ViewingKeyManager.prototype.getAccount = function () {
        var address = bootstrap_1.getAddress();
        return this.accounts.find(function (it) { return it.address === address; });
    };
    ViewingKeyManager.prototype.isEqual = function (a, idOrAddress) {
        return a.contractAddress === idOrAddress || a.id === idOrAddress;
    };
    ViewingKeyManager.prototype.isKeyAdded = function (a, b) {
        return a.contractAddress === b.contractAddress || a.id === b.id;
    };
    return ViewingKeyManager;
}());
exports.ViewingKeyManager = ViewingKeyManager;
var KeplrViewingKeyManager = (function () {
    function KeplrViewingKeyManager(viewingKeyManager) {
        this.viewingKeyManager = viewingKeyManager;
    }
    KeplrViewingKeyManager.prototype.add = function (contract) {
        return __awaiter(this, void 0, void 0, function () {
            var keplr, chainId, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, wallet_1.getKeplr()];
                    case 1:
                        keplr = _a.sent();
                        if (!keplr)
                            throw new Error('Keplr is not installed');
                        return [4, bootstrap_1.getChainId()];
                    case 2:
                        chainId = _a.sent();
                        return [4, keplr.suggestToken(chainId, contract.at)];
                    case 3:
                        _a.sent();
                        return [4, keplr.getSecret20ViewingKey(chainId, contract.at)];
                    case 4:
                        key = _a.sent();
                        this.viewingKeyManager.add(contract, key);
                        return [2, key];
                }
            });
        });
    };
    KeplrViewingKeyManager.prototype.get = function (idOrAddress) {
        return this.viewingKeyManager.get(idOrAddress);
    };
    return KeplrViewingKeyManager;
}());
exports.KeplrViewingKeyManager = KeplrViewingKeyManager;
//# sourceMappingURL=viewing-keys.js.map